import { createContext } from 'react';
import { i18n as I18nInterface } from 'i18next';

type I18n = I18nInterface | undefined;

const i18n = undefined as I18n;

export const I18nContext = createContext<I18n>(i18n);
